var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "div",
        { staticClass: "input-field" },
        [
          _c(
            "v-layout",
            {
              attrs: {
                row: "",
                "align-center": "",
                "justify-space-between": ""
              }
            },
            [
              _c("label", [_vm._v(_vm._s(_vm.$tc("Cable", 2)) + " ")]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "px-0 ma-0",
                  attrs: {
                    small: "",
                    text: "",
                    icon: "",
                    disabled: _vm.disabled
                  },
                  on: { click: _vm.add }
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "accent--text",
                      staticStyle: { "font-size": "14px" }
                    },
                    [_vm._v("\n          add_box\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-slide-y-transition",
        { attrs: { group: "" } },
        [
          _vm._l(_vm.cables, function(cable, index) {
            return [
              _c(
                "v-layout",
                { key: index, attrs: { column: "" } },
                [
                  _c("v-divider", { staticStyle: { margin: "0 20px" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "input-field",
                          attrs: {
                            column: false,
                            "hide-details": true,
                            disabled: _vm.disabled
                          },
                          model: {
                            value: cable.mdec_reserved,
                            callback: function($$v) {
                              _vm.$set(cable, "mdec_reserved", $$v)
                            },
                            expression: "cable.mdec_reserved"
                          }
                        },
                        [
                          _c("v-radio", {
                            attrs: {
                              label: "Existing",
                              value: false,
                              ripple: false,
                              color: "accent"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: {
                              label: "Reservation",
                              value: true,
                              ripple: false,
                              color: "accent"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticStyle: { padding: "0 20px" }, attrs: { xs12: "" } },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            "align-center": "",
                            "justify-space-between": ""
                          }
                        },
                        [
                          _c("v-flex", { attrs: { xs6: "" } }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: cable.mdec_description,
                                  expression: "cable.mdec_description"
                                }
                              ],
                              staticClass: "form-input",
                              staticStyle: { width: "100%", "min-width": "0" },
                              attrs: {
                                placeholder: _vm.$t("Description"),
                                type: "text",
                                disabled: _vm.disabled
                              },
                              domProps: { value: cable.mdec_description },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    cable,
                                    "mdec_description",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs5: "" } },
                            [
                              _c("duct-entry-form-cable-selection-treeselect", {
                                attrs: { placeholder: "Type", cable: cable }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { padding: "0 20px 4px 20px" },
                      attrs: { xs12: "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", "align-center": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs10: "" } },
                            [
                              _c("duct-entry-form-cable-selection-treeselect", {
                                attrs: { placeholder: "Operator", cable: cable }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "px-0 ma-0",
                                  attrs: {
                                    small: "",
                                    text: "",
                                    icon: "",
                                    disabled: _vm.disabled
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.remove(index)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "accent--text",
                                      staticStyle: { "font-size": "14px" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  delete\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42bc2916", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42bc2916","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntryFormCableSelection.vue
// module id = null
// module chunks = 